import { IHeiStorePictureData } from './hei-store-picture.data';
import { IHeiStorePictureProps } from './hei-store-picture.props.autogenerated';

export interface IHeiStorePictureViewProps extends IHeiStorePictureProps<IHeiStorePictureData> {
    storeName: string;
}

const HeiStorePicture = (props: IHeiStorePictureProps<IHeiStorePictureData>) => {
    const {
        data: { allStores },
        config: { orgUnitNumber }
    } = props;

    const store = allStores?.result?.find(s => s.OrgUnitNumber === orgUnitNumber);
    if (!store) {
        return null;
    }

    return props.renderView({
        ...props,
        storeName: store.OrgUnitName
    });
};

export default HeiStorePicture;
